// Support both local development (.env via REACT_APP_*) and Docker runtime (window.env.*)
// Priority:
// 1. Local .env file (process.env.REACT_APP_SERVER_URL)
// 2. Docker runtime environment (window.env.SERVER_URL)
// 3. Default fallback
export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL ||
  window.env?.SERVER_URL ||
  'http://localhost:3000'